// extracted by mini-css-extract-plugin
module.exports = {"cus-mtdicon":"hN","cusMtdicon":"hN"};